import AvatarsList from 'core/modules/components/lists/AvatarsList';
import PropTypes from 'prop-types';
import React from 'react';
import { useHorizontalStudentsProgress } from './useHorizontalStudentsProgress';

const HorizontalStudentsProgress = ({ students, t, scoreScale }) => {
  const { groups, listLabel } = useHorizontalStudentsProgress({ students, t });

  return (
    <div className="horizontal-students-progress">
      <div className="horizontal-students-progress__wrapper">
        {groups.length > 0 && (
          <ul aria-label={listLabel} className="horizontal-students-progress__list">
            {groups.map((group) => (
              <li key={group.key} className="horizontal-students-progress__item" style={{ left: group.left }}>
                <div aria-hidden="true" className="horizontal-students-progress__item-hover">
                  {group.progressLabel}
                </div>
                <AvatarsList ariaLabel={group.ariaLabel} avatars={group.students} withArrow={true} isScore={true} scoreScale={scoreScale} size="md" />
              </li>
            ))}
          </ul>
        )}

        <div className="horizontal-students-progress__bar">
          <span>0%</span>
          <span>{listLabel}</span>
          <span>100%</span>
        </div>
      </div>
    </div>
  );
};

HorizontalStudentsProgress.propTypes = {
  scoreScale: PropTypes.number,
  students: PropTypes.array,
  t: PropTypes.func,
};

export default HorizontalStudentsProgress;
